export default __webpack_public_path__ + "static/media/instagram-logo-transparent-white.9a0a3771.png";